/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const ListPencilIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g>
      <polygon points="15.5 22.5 12 23.5 13 20 20.502 12.498 23.002 14.998" />
      <path d="M18.502,14.498 L21.002,16.998" />
      <path d="M13,20 L15.5,22.5" />
      <path d="M9,10.5 L13,10.5" />
      <path d="M9,14.5 L13,14.5" />
      <polyline points="7.5 8.5 5 11 3.5 9.5" />
      <polyline points="7.5 12.515 5 15.015 3.5 13.515" />
      <polyline points="9 21.5 0.5 21.5 0.5 0.5 11.499 0.5 16.5 5.5 16.5 13" />
      <polyline points="11.499 0.5 11.5 5.5 16.5 5.5" />
    </g>
  </svg>
);

export default ListPencilIcon;
